export const IMAGE_BASE_URL = 'https://adminpro.xhhx888.cn/app-api'
